export default __webpack_public_path__ + "static/media/withdraw-epoint-step3.9d7668ac.png";